import type { Feedback } from './feedbackType';
import { get, post, put } from '../request';

export interface FetchFeedbackParams {
  category?: string;
  question_id?: string;
  teaching_class_id?: string;
  mine?: boolean;
}

export async function fetchFeedbackApi(params: FetchFeedbackParams = {}) {
  const result = await get<{ feedbacks?: Feedback[]; feedback?: Feedback[] }>('/feedback/', {
    ...params,
    mine: params.mine ? '1' : undefined,
  });
  return result.data;
}

export async function postFeedbackApi(category: string, content: string) {
  const result = await post<{ feedback: Feedback }>('/feedback/', {
    category,
    content,
  });
  return result.data;
}

export async function editFeedbackApi(feedbackId: string, review_status: string) {
  const result = await put<{ feedback: Feedback }>(`/feedback/${feedbackId}/`, {
    review_status,
  });
  return result.data;
}
